import _Modal from './Modal';
import withAction from './WithAction';
import { registerComponent } from '../utils';
const registeredModal = registerComponent(_Modal);
const Modal = withAction(registeredModal);
export default withAction(Modal);